export const PHARMA_TEST_URL = 'totis2.webcase-dev.com'
export const HAIR_TEST_URL = 'hair.webcase-dev.com'
export const HAIR_PROD_URL = 'totis.hair'
export const PHARMA_PROD_URL = 'totispharma.com'

export const GET_ADDRESS_STREET_TYPE = $this => ({
  Бульвар: $this._('Бульвар'),
  Улица: $this._('Улица'),
  алея: $this._('алея'),
  бульвар: $this._('бульвар'),
  "в'їзд": $this._("в'їзд"),
  'вул.': $this._('вул.'),
  дорога: $this._('дорога'),
  квартал: $this._('квартал'),
  лінія: $this._('лінія'),
  'м.': $this._('м.'),
  майдан: $this._('майдан'),
  мікрорайон: $this._('мікрорайон'),
  набережна: $this._('набережна'),
  площа: $this._('площа'),
  'пров.': $this._('пров.'),
  проріз: $this._('проріз'),
  'просп.': $this._('просп.'),
  проїзд: $this._('проїзд'),
  'с-ще.': $this._('с-ще.'),
  'с.': $this._('с.'),
  'смт.': $this._('смт.'),
  тупик: $this._('тупик'),
  узвіз: $this._('узвіз'),
  шосе: $this._('шосе'),
})

export const LOGIN_SOURCE = 'login_phone'
export const ORDER_ANONIM_REGISTRATION_PHONE_SOURCE = 'order_anonim_reg_phone'
export const REGISTRATION_SOURCE = 'reg_phone'
export const ORDER_EMAIL_SOURCE = 'order_email'
export const ORDER_ANONIM_PHONE_SOURCE = 'order_anonim_phone'
export const ORDER_ONE_CLICK_ANONIM_SOURCE = 'order_one_click_anonim_phone'
export const PROFILE_PHONE_SOURCE = 'profile_phone'
export const PROFILE_EMAIL_SOURCE = 'profile_email'
export const TICKET_PHONE_SOURCE = 'ticket_phone'

export const LOGIN_SOCIAL_SOURCE = 'login_oauth2_phone'
export const REGISTRATION_PROFILE_EMAIL_SOURCE = 'reg_profile_email'
